import React, { Component } from 'react';
import Relay from 'react-relay/classic';
import { ActivityIndicator } from '@lyearn-team/frontend-components';

import { LearnerViewCardsRC } from '../../../../learner/views/learnerViewCards-Dark';
import User from '../../../../helper/currentUser';

const user = new User();

class PreviewCourse extends Component {
  constructor(props) {
    super(props);
    if (window.self !== window.top) {
      window.parent.hideIframeLoader();
    }
  }

  render() {
    if (this.props.loading) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            minHeight: '80vh',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <ActivityIndicator width={60} height={60} />
        </div>
      );
    }
    const course = this.props.rootQ.previewOffer;
    // style={{ height: '100vh', overflow: 'auto' }}
    return (
      <div className="preview-course-wrapper">
        <LearnerViewCardsRC
          rootQ={course}
          previewCourse={true}
          courseId={this.props.params.courseId}
          cardId={this.props.params.cardId}
          userId={user.id() || '591b0f025ead40001a6473b6'}
          pathId="-1"
        />
      </div>
    );
  }
}

export default Relay.createContainer(PreviewCourse, {
  initialVariables: {
    courseInfo: null
  },
  fragments: {
    rootQ: () => Relay.QL`
      fragment on Viewer {
        previewOffer(offer: $courseInfo) {
          id
          pid
          name
          sections (first: 500) {
            edges {
              node {
                cards (first: 500) {
                  edges {
                    node {
                      pid
                      name
                      id
                    }
                  }
                }
              }
            }
          }
          ${LearnerViewCardsRC.getFragment('rootQ', { userId: user.id(), pathId: '-1' })}
        }
      }
    `
  }
});
